import { DcpProductType } from '@dh-io-pls/pls-ui-types';

export function convertStringToDcpProductTypeEnum(typeString: string): DcpProductType {
  if (Object.values(DcpProductType).includes(typeString as DcpProductType)) {
    return typeString as DcpProductType;
  }

  return DcpProductType.NCOS_D_STANDARD;
}
